<template>
  <div class="pt-10" id="articles">
    <Title text="Articles" class="my-5" />

    <LoadingSpinner v-if="loading.display" :message="loading.message" />

    <div v-else>
      <div v-if="!noArticles">
        <div class="flex justify-between mb-4">
          <div class="flex flex-col">
            <Search @search="search" />
            <p v-if="noFilteredArticles" class="mt-2">No articles</p>
          </div>
          <p v-if="!noFilteredArticles" class="my-auto text-sm">
            Page {{ pageNumber }}
          </p>
        </div>

        <div class="grid lg:grid-cols-2 grid-cols-1 gap-3">
          <div v-for="article in limitArticles" :key="article.id">
            <Article
              data-aos="fade-in"
              data-aos-easing="ease-in-out"
              data-aos-duration="500"
              :header="article.header"
              :image="article.imagePreview"
              :author="article.author"
              :identifier="article.id"
            />
          </div>
        </div>
      </div>
      <p v-else>No articles</p>
      <ExtraPages :num="pages" @handleClick="changePageNum" />
      <LineBreak />
    </div>
  </div>
</template>

<script>
import LoadingSpinner from "../../LoadingSpinner.vue";
import { mapGetters } from "vuex";
import initData from "../../../mixins/initData";
import loader from "../../../mixins/loader";
import Article from "./Article.vue";
import Title from "../Title.vue";
import ExtraPages from "../../ExtraPages.vue";
import Search from "../../Search.vue";
import LineBreak from "../../LineBreak.vue";
import { itemsPerPage, numberOfPages } from "../../../utils/itemsPerPage";

export default {
  name: "Articles",
  mixins: [initData, loader],

  components: {
    LoadingSpinner,
    Article,
    Title,
    ExtraPages,
    Search,
    LineBreak,
  },

  data() {
    return {
      searchInput: "",
      max: 10,
      pageNumber: 1,
    };
  },

  computed: {
    ...mapGetters(["directory", "articlesID"]),

    filterArticles() {
      return this.directory.articles.filter((article) => {
        const { header } = article;
        return header.toLowerCase().includes(this.searchInput.toLowerCase());
      });
    },

    limitArticles() {
      return itemsPerPage(this.filterArticles, this.max, this.pageNumber);
    },

    noArticles() {
      return this.directory.articles.length === 0;
    },

    noFilteredArticles() {
      return this.filterArticles.length === 0;
    },

    pages() {
      return numberOfPages(this.filterArticles, this.max);
    },
  },

  methods: {
    search(text) {
      this.pageNumber = 1;
      this.searchInput = text;
    },

    changePageNum(index) {
      this.pageNumber = index;
    },
  },

  async created() {
    if (this.noArticles) {
      await this.load(this.initData(this.articlesID), "Loading articles");
    }
  },
};
</script>

